import { ErrorMessages } from "../../helpers/data"

export default {
    namespaced: true,

    state: {
        error: false
    },

    actions: {
        aggregateErrors({ commit, dispatch }, { error }) {
            commit("setError", { error: false })

            if (error.status == 500 || error.status == 502 || error.status == "error") {
                commit("setError", { error: true })

                dispatch("modal/open", {
                    title: ErrorMessages.service_unavailable.title,
                    text: ErrorMessages.service_unavailable.text,
                    type: "error",
                    callback: () => {
                        window.location.replace(window.location.origin + "/help/application/");
                    },
                }, { root: true });
                return;
            }
        },
    },

    mutations: {
        setError(state, { error }) {
            state.error = error;
        }
    }
};
